import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitRatingBlock } from '@/fo/ui/kit/rating/block';

import { ShowMoreButton } from '../components/ShowMoreButton/ShowMoreButton';
import { PostComment } from '../types';

import { styles } from './UiCommentSectionBase.styles';

export interface UiCommentSectionBaseProps {
  comments: PostComment[];
  commentsCount: number;
  rating: number;
  onOpenForm: () => void;
  onLoadMore: () => void;
  showLoadMore: boolean;
  commentsLoading: boolean;
}

export function UiCommentSectionBase({
  comments,
  commentsCount,
  rating,
  onOpenForm,
  onLoadMore,
  showLoadMore,
  commentsLoading
}: UiCommentSectionBaseProps) {
  const slots = styles();
  const t = useTranslations();

  return (
    <div className={slots.base()}>
      <div className={slots.comments()}>
        <div className={slots.mobileRating()}>
          <UiKitRatingBlock value={rating} />
        </div>
        <div className={slots.commentsTitle()}>
          <span className={slots.title()}>{t('comment.title')}</span>

          {commentsCount > 0 && (
            <span className={slots.count()}>{commentsCount}</span>
          )}
        </div>
        <div className={slots.commentsHeader()}>
          <UiKitButtonBase
            className={slots.button()}
            onClick={onOpenForm}
          >
            {t('comment.addComment')}
          </UiKitButtonBase>
        </div>
        <div className={slots.commentsList()}>
          {comments.map((comment) => (
            <div key={comment.id}>
              <div className={slots.commentHeader()}>
                <div className={slots.author()}>{comment.author}</div>
                <div className={slots.createdAt()}>{comment.createdAt}</div>
              </div>
              <div className={slots.comment()}>{comment.comment}</div>
            </div>
          ))}
        </div>
        {showLoadMore && (
          <ShowMoreButton
            onClick={onLoadMore}
            isLoading={commentsLoading}
          >
            {t('comment.form.buttons.showMore')}
          </ShowMoreButton>
        )}
      </div>
      <div className={slots.sidebar()}>
        <div>
          <UiKitButtonBase
            className={slots.button()}
            onClick={onOpenForm}
          >
            {t('comment.addComment')}
          </UiKitButtonBase>
          <UiKitRatingBlock value={rating} />
        </div>
      </div>
    </div>
  );
}
